import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function UpdateBusConfig() {
    return <FontAwesomeIcon icon={faEllipsisV} size="lg" />;
}
